import React from "react";
import "../assets/styles/components/ACGVOPage.css";
import SEO from "./SEO";
import HeroBanner from "./HeroBanner";
import Clients from "./Clients";
import Services from "./Services";
import ContactForm from "./ContactForm";

import Arguments from "./Arguments";
import Temoignages from "./Temoignages";
import NotreEquipe from "./NotreEquipe";
import APropos from "./APropos";
import CaracteristiquesCarousel from "./CaracteristiquesCarousel";
import CaracteristiquesList from "./CaracteristiquesList";
import { ToastContainer } from "react-toastify";


const ACGVOPage = () => {
  return (
    <div className="acgvo-page">

<div>
      <SEO
        title="ACG VO - location de bureaux à Villiers-le-Bel, local de coworking proche de Sarcelles"
        description="Location de bureaux à Villiers-Le-Bel. Espaces de travail partagé - coworking de qualité, proche de Sarcelles, dans un quartier calme et fréquenté. Découvrez ACG-VO, votre partenaire pour la location de bureaux, salles de réunion et espaces partagés au cœur du Val d'Oise."
        keywords="location de bureaux, location locaux, Villiers-le-Bel, local, coworking, Sarcelles"
      />
      
        <HeroBanner />
        <Clients />
        <Arguments />
        <Services /> 
        <CaracteristiquesCarousel />
        <CaracteristiquesList />
        <Temoignages /> 
        <APropos /> 
        <NotreEquipe /> 
        {/*
        */}
        <ContactForm />
        <ToastContainer />
    </div>


      {/* Header with Bootstrap Navbar */}
      




    </div>
  );
};

export default ACGVOPage;
